import { AfterViewInit, Component, ElementRef, Input, OnDestroy } from '@angular/core';
import SwiperCore, { Navigation, Pagination, Swiper } from 'swiper';

SwiperCore.use([Navigation, Pagination, Swiper]);

interface MediaSlide {
    imageSrc?: string;
    imageAlt?: string;
    videoSrc?: string;
    videoPoster?: string;
}

@Component({
    selector: 'app-media-slider',
    templateUrl: './media-slider.component.html',
    styleUrls: ['./media-slider.component.scss']
})
export class MediaSliderComponent implements AfterViewInit, OnDestroy {
    @Input() sectionId = '';
    @Input() title = '';
    @Input() slides: MediaSlide[] = [];
    @Input() withBackground = false;

    private slider?: Swiper;

    constructor(private hostRef: ElementRef<HTMLElement>) {}

    ngAfterViewInit() {
        const host = this.hostRef.nativeElement;
        const container = host.querySelector('.swiper-container') as HTMLElement;
        const nextEl = host.querySelector('.swiper-button-next') as HTMLElement;
        const prevEl = host.querySelector('.swiper-button-prev') as HTMLElement;
        const paginationEl = host.querySelector('.swiper-pagination') as HTMLElement;

        this.slider = new Swiper(container, {
            slidesPerView: 1.15,
            spaceBetween: 16,
            navigation: { nextEl, prevEl },
            pagination: { el: paginationEl, clickable: true },
            breakpoints: {
                768: {
                    slidesPerView: 1.6,
                    spaceBetween: 24
                },
                1200: {
                    slidesPerView: 2,
                    spaceBetween: 24
                }
            }
        });
    }

    ngOnDestroy() {
        if (this.slider) {
            this.slider.destroy(true, true);
        }
    }
}
